import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { ContentfulMarkdown } from "#/services/contentful/contentful-markdown-renderer"
import type { ContentBlockWithIconNode } from "../renderer/types"

const iconDisplaySizeMap: Record<"large" | "medium" | "small", number> = {
  small: 24,
  medium: 60,
  large: 120
}

export function ContentBlockWithIconContent({ content }: { content: ContentBlockWithIconNode }) {
  const iconSize =
    content.iconDisplaySize === "custom"
      ? content.customSize ?? iconDisplaySizeMap.medium
      : iconDisplaySizeMap[content.iconDisplaySize] ?? iconDisplaySizeMap.medium

  const icon = content.iconUrl && (
    <Box component="img" src={content.iconUrl} height={iconSize} width={iconSize} alt="" />
  )
  const body = content.body && <ContentfulMarkdown>{content.body}</ContentfulMarkdown>

  return (
    <Box
      display="flex"
      gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      paddingTop={(theme) => theme.spacing(theme.tokens.spacing.xs)}
      paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.lg)}
      alignItems="center"
      flexDirection={content.iconAlignment === "start" ? "row" : "row-reverse"}
    >
      {icon}
      <Box flex={1}>{body}</Box>
    </Box>
  )
}
